const augmentation = {
  // common
  "augmentation-title": "Data Augmentation",
  "augmentation-coming-soon": "Coming soon",

  // causal graph area
  "augmentation-fitting": "Fitting",
  "augmentation-fitting-in-progress": "Fitting...",
  "augmentation-load-model": "Load Existing Model",
  "augmentation-load-graph": "Load Existing Graph",

  // generation history modal
  "augmentation-history-button": "This Month's History",
  "augmentation-history-title": "History",
  "augmentation-history-model": "Model",
  "augmentation-history-datapoints": "Data Points",
  "augmentation-history-cost": "Amount (tax incl.)",
  "augmentation-history-started": "Started At",
  "augmentation-history-finished": "Finished At",
  "augmentation-history-download": "CSV Download",
  "augmentation-history-download-button": "Download",
  "augmentation-history-close": "Close",
  "augmentation-history-empty": "No generation history this month",

  // data augmentation settings area
  "augmentation-settings-title": "Data Augmentation Settings",
  "augmentation-generation-mode": "Generation Mode",
  "augmentation-mode-normal": "Normal",
  "augmentation-mode-timeseries": "Time Series",
  // Time-series mode
  "augmentation-ts-num-series": "Number of Series",
  "augmentation-ts-cycle": "Cycle Unit",
  "augmentation-ts-granularity": "Granularity",
  "augmentation-ts-start": "Start Date",
  "augmentation-ts-end": "End Date",
  "augmentation-ts-time-points": "Time Points",
  "augmentation-cycle-none": "None",
  "augmentation-cycle-year": "Year",
  "augmentation-cycle-month": "Month",
  "augmentation-cycle-week": "Week",
  "augmentation-granularity-date": "Day",
  "augmentation-granularity-week": "Week",
  "augmentation-granularity-month": "Month",
  // Generation range
  "augmentation-range-title": "Generation Range",
  "augmentation-range-min": "Min",
  "augmentation-range-max": "Max",
  "augmentation-range-categorical": "Not available for categorical variables",
  "augmentation-seed-data": "Seed Data",
  "augmentation-augmented-rows": "Set the number of Augmented Rows",
  "augmentation-input": "Input",
  "augmentation-augmented-data": "Augmented Data",
  "augmentation-rows": "Number of Rows",
  "augmentation-columns": "Number of Columns",
  "augmentation-data-points": "Number of Data Points",
  "augmentation-charge": "Charge",
  "augmentation-charge-tax": "(tax included)",
  "augmentation-charge-cumulative": "{{ym}} cumulative",
  "augmentation-generate": "Generate",
  "augmentation-reset": "Reset",
  "augmentation-generating": "Generating...",
  "augmentation-generate-success": "Data generation completed.",
  "augmentation-generate-error": "Data generation failed.",

  // result area
  "augmentation-download": "Download",
  "augmentation-dist-compare":
    "Comparison of distributions with the original data (KL/JS Divergence)",
  "augmentation-corr-compare": "Comparison of correlations between variables",
  "augmentation-kl-divergence": "KL divergence",
  "augmentation-js-divergence": "JS divergence",
  "augmentation-summary-source-rows": "Original Data Count",
  "augmentation-summary-columns": "Column Count",
  "augmentation-summary-generated-rows": "Generated Data Count",
  "augmentation-legend-seed": "Seed Data",
  "augmentation-legend-augmented": "Augmented Data",
  "augmentation-corr-matrix-seed": "Correlation Matrix Heatmap (Seed Data)",
  "augmentation-corr-matrix-generated":
    "Correlation Matrix Heatmap (Augmented Data)",
  "augmentation-corr-max-pair": "Largest-difference pair",
};

export default augmentation;
